// Setting Individual Approver
const SET_INDIVIDUAL_APRROVER = 'SET_INDIVIDUAL_APRROVER';
const CLEAR_INDIVIDUAL_APRROVER_LIST = 'CLEAR_INDIVIDUAL_APRROVER_LIST';
const DELETE_ALL_INDIVIDUAL_LIST = 'DELETE_ALL_INDIVIDUAL_LIST';

// Set Individual approvers in list
const setIndividualApprovers = (approversData) => ({
  type: SET_INDIVIDUAL_APRROVER,
  payload: {
    approversData,
  },
});
// When user Clicks on cross button
const clearApproverList = (email) => ({
  type: CLEAR_INDIVIDUAL_APRROVER_LIST,
  payload: email,
});
// Delete all indivual approver list formID
const deleteAllIndidualList = (formId) => ({
  type: DELETE_ALL_INDIVIDUAL_LIST,
  payload: formId,
});

export {
  setIndividualApprovers,
  clearApproverList,
  deleteAllIndidualList,
  SET_INDIVIDUAL_APRROVER,
  CLEAR_INDIVIDUAL_APRROVER_LIST,
  DELETE_ALL_INDIVIDUAL_LIST,
};
